import CookiesModal from '@/Components/CookiesModal.jsx';
import TermsAndConditionsModal from '@/Components/TermsAndConditionsModal.jsx';
import {PagesStyle} from '@/Styles/pages.js';
import {Box, Link as MuiLink} from '@mui/material';
import * as React from 'react';
import {memo} from 'react';

const LegalMenu = () => {
    const items = [
        {
            key: 'layout-footer-nav-data-protection-regulation',
            label: 'Demande relative au RGPD',
            href: 'https://www.mitsubishielectric.com/contact/ssl/php/1102/inquiryform.php?fid=1102',
        },
        {
            key: 'layout-footer-nav-privacy-policy',
            label: 'Politique de confidentialité',
            href: 'https://emea.mitsubishielectric.com/fr/privacy/index.html',
        },
    ];

    return (
        <Box component="nav">
            <Box component="ul" sx={listStyle}>
                <Box component="li" sx={listItemStyle}>
                    <TermsAndConditionsModal key="layout-footer-nav-terms-of-service" />
                </Box>
                {items.map(({href, key, label}) => (
                    <Box key={key} component="li" sx={listItemStyle}>
                        <MuiLink target="_blank" href={href} key={key} underline="none" variant="button">
                            {label}
                        </MuiLink>
                    </Box>
                ))}
                <Box component="li" sx={listItemStyle}>
                    <CookiesModal key="layout-footer-nav-cookies-policy" />
                </Box>
            </Box>
        </Box>
    );
};

const listStyle = {
    ...PagesStyle.list,
    display: 'flex',
    alignItems: 'center',
    ['@media (max-width: 800px)']: {
        flexWrap: 'wrap',
    },
};
const listItemStyle = (theme) => ({
    ...PagesStyle.list_item,
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    ':not(:last-child)': {
        mr: 2,
        pr: 2,
        borderRight: '1px solid black',
    },
    '& a': {
        color: 'inherit',
        whiteSpace: 'nowrap',
        ':hover': {
            color: theme.palette.primary.main,
        },
    },
});

export default memo(LegalMenu);
